<div class="service-timeline" [class.service-timeline--canceled]="isCanceled()" data-testid="service-timeline">
  @if (isError()) {
    <div class="service-timeline__error" data-testid="service-timeline-error">
      <p>{{ isError() }}</p>
      <button mat-button color="primary" (click)="retry()" [disabled]="isLoading()" data-testid="service-timeline-retry-btn">Reintentar</button>
    </div>
  }

  @else if (isLoaded()) {
    <div class="service-timeline__container" data-testid="service-timeline-container">
        @for (step of steps(); track step.status + step.date + i; let i = $index; let last = $last) {
          <div
            class="service-timeline__step"
            [class.service-timeline__step--completed]="step.stepState === 'completed'"
            [class.service-timeline__step--active]="step.stepState === 'active'"
            [class.service-timeline__step--canceled]="step.stepState === 'canceled'"
            [class.service-timeline__step--last]="last"
            [attr.data-testid]="'service-timeline-step-' + i"
          >
            <div class="service-timeline__circle">
              @if (step.stepState === 'completed' || step.stepState === 'active') {
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 21 21" fill="none">
                  <path d="M9.11288 13.3071L6.41725 10.6115L5.25977 11.769L9.11288 15.6221L17.0589 7.67604L15.9015 6.51855L9.11288 13.3071Z" fill="white"/>
                </svg>
              }
              @else if (step.stepState === 'canceled') {
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                  <path d="M15.0137 5.17933L13.9562 4.12183L9.76367 8.31433L5.57117 4.12183L4.51367 5.17933L8.70617 9.37183L4.51367 13.5643L5.57117 14.6218L9.76367 10.4293L13.9562 14.6218L15.0137 13.5643L10.8212 9.37183L15.0137 5.17933Z" fill="white"/>
                </svg>
              }
            </div>

            <div class="service-timeline__content">
              <div class="service-timeline__title">{{ step.title }}</div>
              @if (step.date) {
                <div class="service-timeline__date">{{ step.date | date:'dd/MM/yy hh:mm a' }}</div>
              }
              @if (step.showViewMore) {
                <button class="service-timeline__view-more" (click)="onViewMore(step, $event)" [attr.data-testid]="'service-timeline-view-more-' + i">
                  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M6 2C3.791 2 2 3.791 2 6C2 8.209 3.791 10 6 10C8.209 10 10 8.209 10 6C10 3.791 8.209 2 6 2ZM6 9.25C4.205 9.25 2.75 7.795 2.75 6C2.75 4.205 4.205 2.75 6 2.75C7.795 2.75 9.25 4.205 9.25 6C9.25 7.795 7.795 9.25 6 9.25Z" fill="#FBCF50"/>
                    <path d="M6 4.5C5.724 4.5 5.5 4.724 5.5 5V6.75C5.5 7.026 5.724 7.25 6 7.25C6.276 7.25 6.5 7.026 6.5 6.75V5C6.5 4.724 6.276 4.5 6 4.5Z" fill="#FBCF50"/>
                    <circle cx="6" cy="8" r="0.5" fill="#FBCF50"/>
                  </svg>
                  VER MÁS
                </button>
              }
            </div>
          </div>
        }
    </div>
  }
  @else {
    <div class="service-timeline__message" data-testid="service-timeline-loading">
      <app-horus-loading size="S"></app-horus-loading>
      <p>Cargando información del servicio...</p>
    </div>
  }
</div>
